module.exports = __webpack_public_path__ + "img/身份标识.2a072082.png";